export default __webpack_public_path__ + "static/media/Read-Bold_V1100.33880d27.woff2";